import { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";

/**
 * HoverList
 * Props:
 * - items: array of items to render
 * - getLink: item => string (path)
 * - getTitle: item => string (link text)
 * - icon: React node to show before count
 * - label: string label after count (e.g., 'Peticiones')
 * - count: number to display (optional; falls back to items.length)
 *
 * Renders a trigger + popup. Handles mouse enter/leave with a small hide delay
 * and keeps popup open when moving between trigger and popup.
 */
const HoverList = ({
  items = [],
  getLink,
  getTitle,
  icon,
  label,
  count,
  onOpenChange,
}) => {
  const [open, setOpen] = useState(false);
  const hideTimeoutRef = useRef(null);

  const handleEnter = () => {
    if (hideTimeoutRef.current) {
      clearTimeout(hideTimeoutRef.current);
      hideTimeoutRef.current = null;
    }
    setOpen(true);
  };

  const handleLeave = () => {
    if (hideTimeoutRef.current) clearTimeout(hideTimeoutRef.current);
    hideTimeoutRef.current = setTimeout(() => {
      setOpen(false);
      hideTimeoutRef.current = null;
    }, 180);
  };

  useEffect(() => {
    return () => {
      if (hideTimeoutRef.current) {
        clearTimeout(hideTimeoutRef.current);
        hideTimeoutRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    if (typeof onOpenChange === "function") onOpenChange(open);
  }, [open, onOpenChange]);

  return (
    <div
      className="ContactCard__adsWrapper"
      onMouseEnter={handleEnter}
      onMouseLeave={handleLeave}
      onFocus={handleEnter}
      onBlur={handleLeave}
      tabIndex={0}
    >
      <p>
        {icon}
        {typeof count === "number" ? count : items.length} {label}
      </p>

      {open && items && items.length > 0 && (
        <div
          className="ContactCard__adsHover"
          role="dialog"
          aria-label={label}
          onMouseEnter={handleEnter}
          onMouseLeave={handleLeave}
        >
          {items.map((item) => (
            <Link
              key={item._id}
              to={getLink(item)}
              className="ContactCard__adsHover__link"
            >
              {getTitle(item)}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default HoverList;
